import { NameDto } from '../../Common/Types'

export interface NotificationContactDetailsDto {
  tickmillCompany: NameDto
  supportPhoneNumber: string
  supportEmail: string
}

export interface CreateNotificationContactDetailsDto {
  supportPhoneNumber: string
  supportEmail: string
}

export interface UpdateNotificationContactDetailsDto {
  tickmillCompanyId: number
  supportPhoneNumber: string
  supportEmail: string
}

export enum NotificationContactDetailsPageKey {
  entity = 'tickmillCompany.name',
  supportPhoneNumber = 'supportPhoneNumber',
  supportEmail = 'supportEmail',
}
